const SortDirection = {
    ASC: 'ASC',
    DESC: 'DESC'
}
export default SortDirection;